import Ionicons from '@expo/vector-icons/Ionicons';
import { type ComponentProps } from 'react';
import { Pressable, Text, View } from 'react-native';

type IoniconsName = ComponentProps<typeof Ionicons>['name'];

interface AdminDashboardCardProps {
  icon: IoniconsName;
  title: string;
  subtitle: string;
  count?: number;
  onPress: () => void;
}

export function AdminDashboardCard({
  icon,
  title,
  subtitle,
  count,
  onPress,
}: AdminDashboardCardProps) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={title}
      className="bg-surface"
      style={{
        borderRadius: 12,
        padding: 16,
        marginBottom: 12,
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <View
        className="bg-surface-secondary"
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: 14,
        }}
      >
        <Ionicons name={icon} size={22} className="text-primary" />
      </View>
      <View style={{ flex: 1 }}>
        <Text className="text-foreground" style={{ fontSize: 16, fontWeight: '600' }}>
          {title}
        </Text>
        <Text className="text-muted-foreground" style={{ fontSize: 13, marginTop: 2 }}>
          {subtitle}
        </Text>
      </View>
      {count !== undefined && (
        <View
          className="bg-primary"
          style={{
            borderRadius: 12,
            minWidth: 28,
            height: 28,
            alignItems: 'center',
            justifyContent: 'center',
            paddingHorizontal: 8,
            marginRight: 8,
          }}
        >
          <Text className="text-background" style={{ fontSize: 14, fontWeight: '600' }}>
            {count}
          </Text>
        </View>
      )}
      <Ionicons name="chevron-forward" size={20} className="text-muted-foreground" />
    </Pressable>
  );
}
